import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { history } from '../../state/store';
import moment from 'moment';

import EventApi from '../../api/event';

import withEhsPageBehavior from '../../withEhsPageBehavior';

class SchedulePage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            checkins: [],
            organizationName: '',
            overall: 0,
        };
        this.deleteEvent = this.deleteEvent.bind(this);
    }

    deleteEvent(event, e) {
        e.preventDefault();
        EventApi.delete(event.id).then(result => {
            console.log('deleted, now what?');
            history.go(0);
        });
    }

    componentDidMount() {
        // OrganizationApi.getEvents(this.props.match.params.organizationId).then(events => {
        //     var startDate = moment(events[0].organization.start_date);
        //     var nowDate = moment();
        //     var targetDate = moment(events[0].organization.end_date);
        //     this.setState({
        //         checkins: events,
        //         organizationName: events[0].organization.name,
        //         targetDate: moment(events[0].organization.end_date),
        //         startDate: moment(events[0].organization.start_date),
        //         totalDays: targetDate.diff(startDate, 'days'),
        //         elapsedDays: nowDate > startDate ? nowDate.diff(startDate, 'days') : '0'
        //     });
        // });
    }

    getPracticeDisplay = practice => {
        if (practice.primary_practice === true) {
            return (
                <div>
                    <i className="fa fa-hospital-o" /> {practice.name}
                </div>
            );
        } else {
            return <div>{practice.name}</div>;
        }
    };

    compareValues = (key, sortOrder = 'asc') => {
        return function(a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                console.error(
                    `Error: Could not sort items by the key "${key}" because it does not exist on either object being compared.`
                );
                return 0;
            }

            const varA =
                typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
            const varB =
                typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }

            const result = sortOrder === 'desc' ? comparison * -1 : comparison;

            return result;
        };
    };

    getSortedEvents = () => {
        // Sort the table items by practice.
        const sortedEventsByPractice = [...this.props.events].sort(
            this.compareValues('practices')
        );

        // Then sort the table items by date.
        const sortedEventsByDate = sortedEventsByPractice.sort(
            this.compareValues('date')
        );

        const tableItems = sortedEventsByDate.map(evt => (
            <tr key={evt.id + '_key'}>
                <td>{evt.checkin}</td>
                <td>{evt.name}</td>
                <td>{moment(evt.date).format('M/D/YYYY')}</td>
                <td align="center">
                    {evt.complete === true ? (
                        <i className="fa fa-check-circle-o" />
                    ) : (
                        <i className="fa fa-circle-o" />
                    )}
                </td>
                <td>
                    {evt.practices.map(practice => (
                        <span key={practice.id}>
                            {this.getPracticeDisplay(practice)}
                        </span>
                    ))}
                </td>
                <td className="Actions">
                    <Link
                        to={
                            '/organization/' +
                            evt.organization.id +
                            '/schedule/' +
                            evt.id +
                            '/edit'
                        }
                        title="Edit deadline">
                        <i className="fa fa-edit" />
                    </Link>
                    <Link
                        to={``}
                        title="Remove deadline"
                        onClick={e => {
                            this.deleteEvent(evt, e);
                        }}>
                        <i className="fa fa-trash" />
                    </Link>
                </td>
            </tr>
        ));

        return tableItems;
    };

    render() {
        return (
            <table className="table-schedule">
                <thead>
                    <tr>
                        <th>Check-In</th>
                        <th>Title</th>
                        <th>Date</th>
                        <th>Complete</th>
                        <th>Associated Practices</th>
                        <th />
                    </tr>
                </thead>
                <tbody>{this.getSortedEvents()}</tbody>
            </table>
        );
    }
}
export default withEhsPageBehavior(SchedulePage);
